var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.5 22.5H4.5C4.10232 22.4995 3.72105 22.3414 3.43984 22.0602C3.15864 21.7789 3.00046 21.3977 3 21V3C3.00046 2.60232 3.15864 2.22105 3.43984 1.93984C3.72105 1.65864 4.10232 1.50046 4.5 1.5H13.5C13.8977 1.50046 14.279 1.65864 14.5602 1.93984C14.8414 2.22105 14.9995 2.60232 15 3V5.25H13.5V3H4.5V21H13.5V18.75H15V21C14.9995 21.3977 14.8414 21.7789 14.5602 22.0602C14.279 22.3414 13.8977 22.4995 13.5 22.5ZM18.129 12.75L15.4395 15.4395L16.5 16.5L21 12L16.5 7.5L15.4395 8.5605L18.129 11.25H7.5V12.75H18.129Z",
  fill: "currentColor"
});

var SvgLogoutIcon = function SvgLogoutIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoutIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/LogoutIcon.9e7ca602.svg";
export { ForwardRef as ReactComponent };